import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";

window.WalletConnect = WalletConnect;
window.QRCodeModal = QRCodeModal;
